<template>
    <div class="flex space-x-4">
        <div class="w-full">
            <label for="start-date" class="block mb-2 text-sm font-medium text-gray-700">Start dato</label>
            <input type="date" id="start-date" v-model="localStartDate"
                class="block w-full px-3 py-2 mt-1 text-sm bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500">
        </div>
        <div class="w-full">
            <label for="end-date" class="block mb-2 text-sm font-medium text-gray-700">Slut dato</label>
            <input type="date" id="end-date" v-model="localEndDate"
                class="block w-full px-3 py-2 mt-1 text-sm bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500">
        </div>
    </div>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue';

const props = defineProps({
    startDate: Date,
    endDate: Date,
});

const emit = defineEmits(['update:startDate', 'update:endDate']);

const localStartDate = ref(props.startDate.toISOString().split('T')[0]);
const localEndDate = ref(props.endDate.toISOString().split('T')[0]);

watch(localStartDate, (newValue) => {
    emit('update:startDate', new Date(newValue));
});

watch(localEndDate, (newValue) => {
    emit('update:endDate', new Date(newValue));
});
</script>